// stores/companyAccessStore.js
'use client';

import { mutate } from 'swr';
import { fleetApi } from 'api/axiosClient';

const getTzParam = () => `?tz=${Math.abs(new Date().getTimezoneOffset() / 60)}`;

export const revalidateCompanyAccessList = () => {
  mutate((key) => Array.isArray(key) && key[0] === '/user-company-access/search');
};

/**
 * assignCompanyAccess
 * POST /assign-company-access/add
 * payload: { data: [{ user_access: <id>, company_access: <id> }, ...] }
 */
export const assignCompanyAccess = async (userId, companyIds = []) => {
  if (userId == null) throw new Error('userId is required');
  if (!Array.isArray(companyIds)) throw new Error('companyIds must be an array');

  try {
    const data = companyIds.map((c) => ({
      user_access: Number(userId),
      company_access: Number(c)
    }));

    const body = { data };

    const response = await fleetApi.post(`/assign-company-access/add${getTzParam()}`, body);

    revalidateCompanyAccessList();
    return response?.data ?? null;
  } catch (error) {
    console.error('Failed to assign company access:', {
      userId,
      companyIds,
      status: error?.response?.status,
      responseData: error?.response?.data,
      message: error?.message
    });
    throw error;
  }
};

export const updateCompanyAccess = async (userId, companyIds = []) => {
  return assignCompanyAccess(userId, companyIds);
};
